import __vue_normalize__ from '@gig/magic-wand/dist/build/rollup/vue-helpers/normalize-component.js';
import __vue_create_injector__ from 'vue-runtime-helpers/dist/inject-style/browser.mjs';
import magicStyles from './terms-updated-prompt.magic.css.js';
import TermsUpdatedPromptComponent from './terms-updated-prompt.js';

const __vue_script__ = TermsUpdatedPromptComponent;

/* template */
var __vue_render__ = function() {
  var _vm = this;
  var _h = _vm.$createElement;
  var _c = _vm._self._c || _h;
  return _c(
    "div",
    {
      staticClass: "terms-updated-prompt",
      attrs: {
        part: "terms-updated-prompt",
        "data-v-test-id": "terms-updated-prompt"
      }
    },
    [
      _c("magic-ui-icon", {
        staticClass: "icon",
        attrs: { badge: "", name: "padlock", part: "icon" }
      }),
      _vm._v(" "),
      _c("magic-ui-text", {
        staticClass: "text",
        attrs: { part: "text", content: _vm.$t("terms-updated.introduction") }
      }),
      _vm._v(" "),
      _vm._l(_vm.updatedSummaries, function(summary, index) {
        return _c("magic-ui-text", {
          key: index,
          staticClass: "text text--summary",
          attrs: {
            "data-v-test-id": "terms-updated-prompt-text",
            part: "text text--summary",
            content: summary
          }
        })
      }),
      _vm._v(" "),
      _c(
        "div",
        { staticClass: "action", attrs: { part: "action" } },
        [
          _c("magic-ui-button", {
            attrs: {
              "data-v-test-id": "terms-updated-prompt-agree",
              wide: "",
              variant: "primary",
              loading: _vm.isLoading
            },
            domProps: { innerHTML: _vm._s(_vm.$t("terms-updated.button")) },
            on: { click: _vm.agree }
          }),
          _vm._v(" "),
          _c("magic-ui-button", {
            attrs: {
              "data-v-test-id": "terms-updated-prompt-disagree",
              hollow: "",
              wide: "",
              variant: "primary",
              disabled: _vm.isLoading
            },
            domProps: { innerHTML: _vm._s(_vm.$t("terms-updated.decline")) },
            on: { click: _vm.decline }
          })
        ],
        1
      )
    ],
    2
  )
};
var __vue_staticRenderFns__ = [];
__vue_render__._withStripped = true;

  /* style */
  const __vue_inject_styles__ = function (inject) {
    if (!inject) return
    inject("data-v-5d38cb85_0", { source: magicStyles, map: undefined, media: undefined });

  };
  /* scoped */
  const __vue_scope_id__ = "data-v-5d38cb85";
  /* module identifier */
  const __vue_module_identifier__ = undefined;
  /* functional template */
  const __vue_is_functional_template__ = false;
  /* style inject SSR */
  
  /* style inject shadow dom */
  

  
  const __vue_component__ = /*#__PURE__*/__vue_normalize__(
    { render: __vue_render__, staticRenderFns: __vue_staticRenderFns__ },
    __vue_inject_styles__,
    __vue_script__,
    __vue_scope_id__,
    __vue_is_functional_template__,
    __vue_module_identifier__,
    false,
    __vue_create_injector__,
    undefined,
    undefined
  );

export default __vue_component__;
